import React from "react"
import { withTranslation } from "react-i18next"
import ContactForm from "./ContactForm"

const ContactInformation = ({ data, t }) => {
  return (
    <div className="accordion custom-accordion px-0">
      <a className="accordion-list mb-2">
        <div className="accordion-title">{t("common:Contact Information")}</div>
      </a>
      <ContactForm t={t} data={data} />
    </div>
  )
}

export default withTranslation(["companyPage", "common"])(ContactInformation)